import React from 'react';
import EventsPortal from '../portal/EventsPortal';
import { HOME_PORTAL } from '../portal/portalConfigs';

const Home = () => <EventsPortal config={HOME_PORTAL} />;

export default Home;
